export enum MobileOrderFg {
  POS_PREPAID = "00", // 포스 선불
  ONETOSS_HOOKING = "08", // 원토스 후킹
  KIOSK = "18", // 키오스크
  NAVER = "20", // 네이버
  HOOKING = "22", // 후킹
  CID = "23", // CID
  TABLE_ORDER = "24", // 테이블오더(OKDC)
  YOGIYO = "27", // 요기요
  BAEMIN = "28", // 배민
  BAEMIN_ONE = "29", // 배민원
  BAEMIN_STORE = "30", // 배민스토어
  YOGIYO_EXPRESS = "31", // 요기요 익스프레스
  PANDA_SELF_DELIVERY = "32", // 헝그리판다(자체배달)
  HUNGRY_PANDA = "33", // 헝그리판다
  WMPO = "34", // 위메프오
  DDANGYO = "35", // 땡겨요
  BMSMILE = "36", // 비엠스마일 (위글루션)
  QR_ORDER = "37", // QR오더
  MONTHLY = "38", // 먼슬리
  HIMNANDA = "39", // 힘난다
  MUKKEBI = "40", // 먹깨비
  HAPPY_ORDER = "41", // 해피오더
  GAMSUNG_COFFEE = "43", // 감성커피
  OLTTEA_AH = "44", // 올때아아
  TALK_PICK = "45", // 톡포장
  BARODER = "46", // 바로더
  THE_LITER = "47", // 더리터
  NAVER_BOOKING = "48", // 네이버 예약
  ROUTINE_COFFEE = "49", // 루틴커피
  DEMONSTRATION = "50", // VD시연용
  NAVERCONNECT = "51", // Npay 커넥트
  DDANGBAEDAL = "52", // 땡배달
  BAEGEOK_COFFEE = "53", // 백억커피
}
